import { Add } from "@mui/icons-material";
import { Box, Button, FormControl, InputAdornment, MenuItem, OutlinedInput, Select, Stack, Typography } from "@mui/material";
import { Fragment, useMemo, useState } from "react";
import PageHeader from "src/components/shared/PageHeader";
import SearchFilterComp from "src/components/shared/SearchFilterComp";
import TabComp from "src/components/shared/TabComp";
import TableComp from "src/components/shared/table/TableComp";
import useAppGlobal from "src/context/useAppGlobal";
import { warehouseSelectList } from "./utils/constant";
import useWarehouseAction from "./utils/useWarehouseAction";
import useWarehouseBody from "./utils/useWarehouseBody";
import WarehouseCreate from "./WarehouseCreate";
import { CHECK_RETURN_PROD_STATUS } from "src/constant";
import useAuthGlobal from "src/context/useAuthGlobal";
import CapacityForm from "./CapacityForm";
import useQueryParams from "src/hooks/useQueryParams";
import BalanceWarehouseTable from "./balance/BalanceWarehouseTable";
import BalanceWarehouseCreate from "./balance/BalanceWarehouseCreate";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";
import SelectComp from "src/components/shared/SelectComp";
const warehouseType = [
  {
    id: CHECK_RETURN_PROD_STATUS.all,
    title: "Tất cả",
  },
  {
    id: CHECK_RETURN_PROD_STATUS.normal,
    title: "Thường",
  },
  {
    id: CHECK_RETURN_PROD_STATUS.factory,
    title: "Xưởng",
  },
];

const tabs = [
  { id: "warehouse", name: "Kho hàng" },
  { id: "balance", name: "Dung tích kho" },
];

export default function WarehouseTable() {
  const permissionCheck = useRoleCheck();
  const { userMe } = useAuthGlobal();
  const { handleOpenDialog } = useAppGlobal();
  const [option] = useQueryParams();
  const [searchBy, setSearchBy] = useState();
  const [keyword, setKeyword] = useState();
  const [type, setType] = useState(CHECK_RETURN_PROD_STATUS.all);
  const [capacity, setCapacity] = useState(null);
  const [value, setValue] = useState();

  const warehouseRole = useMemo(() => {
    const roles = userMe?.role?.rolePermissions?.filter((role) => role?.resource === "Warehouse");
    return roles?.reduce((acc, role) => {
      acc.push(role?.action);
      return acc;
    }, []);
  }, [userMe?.role?.rolePermissions]);

  const action = useWarehouseAction({ warehouseRole });

  const handleSetCapacity = (item) => {
    setCapacity(item);
  };

  const handleCloseCapacity = () => {
    setCapacity(null);
  };

  const { header, bodyList, sortData, total } = useWarehouseBody({
    searchBy,
    keyword,
    warehouseSelectList,
    type,
    onSetCapacity: handleSetCapacity,
    warehouseRole,
    warehouseId: value,
  });

  const handleCreateWarehouse = () => {
    handleOpenDialog({
      title: "Tạo kho hàng",
      size: "md",
      content: <WarehouseCreate />,
    });
  };

  const handleWarehouseConfiguration = () => {
    handleOpenDialog({
      title: "Thiết lập dung tích kho",
      content: <BalanceWarehouseCreate />,
      size: "md",
    });
  };

  return (
    <Fragment>
      <PageHeader
        name="Quản lý Kho"
        subName="Kho"
      />
      <Stack
        gap={1.5}
        my={1.5}
      >
        <Box
          display="flex"
          gap={1}
        >
          {permissionCheck([PERMISSIONS.CREATE_WAREHOUSE_ALL, PERMISSIONS.CREATE_WAREHOUSE_OWN]) && (
            <Button
              onClick={handleCreateWarehouse}
              variant="contained"
              startIcon={<Add />}
            >
              Thêm kho
            </Button>
          )}

          <Button
            disabled={!permissionCheck([PERMISSIONS.CREATE_WAREHOUSE_ALL, PERMISSIONS.CREATE_WAREHOUSE_OWN])}
            variant="contained"
            startIcon={<Add />}
            onClick={handleWarehouseConfiguration}
          >
            Thiết lập dung tích kho
          </Button>
        </Box>

        <TabComp tabs={tabs} />
        {option?.tab === tabs[0]?.id && (
          <>
            <Box
              display="flex"
              gap="6px"
              justifyContent="space-between"
            >
              <Box maxWidth="300px">
                <SearchFilterComp
                  placeholder="Tìm kiếm thông tin kho..."
                  selectList={warehouseSelectList}
                  getSearchKeyword={setKeyword}
                  getSelectKeyword={setSearchBy}
                />
              </Box>
              <Box
                display="flex"
                gap={1}
              >
                {permissionCheck([PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN]) && (
                  <Box sx={{ maxWidth: "180px" }}>
                    <SelectComp
                      input={
                        <OutlinedInput
                          startAdornment={
                            <InputAdornment position="start">
                              <Typography
                                fontWeight="bold"
                                sx={{
                                  borderRight: "1px solid var(--grey)",
                                  pr: "12px",
                                  color: "var(--black)",
                                  fontSize: "12px",
                                }}
                              >
                                Kho
                              </Typography>
                            </InputAdornment>
                          }
                        />
                      }
                      userMe={userMe}
                      value={value}
                      setValue={setValue}
                      item={{ path: "/api/v1/warehouses", params: { limit: 100, skip: 0 } }}
                    />
                  </Box>
                )}
                <FormControl size="small">
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    defaultValue={CHECK_RETURN_PROD_STATUS.all}
                    onChange={(e) => setType(e.target.value)}
                  >
                    {warehouseType.map((v) => {
                      return (
                        <MenuItem
                          value={v?.id}
                          key={v?.id}
                        >
                          {v?.title}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Box>
            </Box>
            <Typography sx={{ fontWeight: "bold" }}>{total < 10 ? "0" + total : total} kho hàng </Typography>
          </>
        )}
      </Stack>
      {option?.tab === tabs[0]?.id && (
        <>
          {!!capacity && (
            <CapacityForm
              item={capacity}
              onClose={handleCloseCapacity}
            />
          )}
          <TableComp
            dynamicWidth={"850px"}
            headers={header}
            sortData={sortData}
            bodyList={bodyList}
            action={action}
          />
        </>
      )}

      {option?.tab === tabs[1]?.id && <BalanceWarehouseTable />}
    </Fragment>
  );
}
